import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
import styled from 'styled-components';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallProviderWrapper = styled.div.withConfig({
  displayName: "ChangeProviderLink__CallProviderWrapper",
  componentId: "sc-1wnxxst-0"
})(["display:flex;flex-direction:column;font-weight:", ";padding:12px 16px 0;"], WEB_FONT_MEDIUM_WEIGHT);
export const getUserPreferencesUrl = () => `${getFullUrlWithCurrentSubDomain()}/settings/${PortalIdParser.get()}/user-preferences/calling`;
export const ChangeProviderLink = ({
  onCallButtonClick,
  providerName,
  className
}) => {
  return /*#__PURE__*/_jsxs(CallProviderWrapper, {
    "data-selenium-test": "selected-help-desk-provider",
    className: className,
    children: [providerName, /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: getUserPreferencesUrl(),
      onClick: onCallButtonClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "callWorkspacePopover.changeCallingProvider"
      })
    })]
  });
};